<template>
	<article class="relative hover:-translate-y-2 transition-transform duration-200">
		<AtomLink
			:url="url"
			:title="title"
		>
			<AtomCard
				class="relative aspect-square overflow-hidden border border-white"
			>
				<AtomImage
					v-bind="featuredImage"
					:width="390"
					:height="390"
					img-class="object-cover size-full"
					fit="cover"
					loading="lazy"
				/>
				<div class="absolute bottom-0 left-0 w-full flex flex-col justify-end p-8 pt-24 bg-gradient-to-t from-black/90 to-black/0">
					<AtomTitle
						tag="h2"
						size="lg"
						class="text-white"
					>
						{{ title }}
					</AtomTitle>
					<p
						v-if="shortDescription"
						class="text-white"
					>
						{{ shortDescription }}
					</p>
				</div>
			</AtomCard>
		</AtomLink>
		<div class="absolute p-8 top-0 left-0 w-full flex justify-between gap-4 pointer-events-none">
			<div>
				<div class="flex flex-wrap gap-4">
					<h3 class="sr-only">
						Tags
					</h3>
					<AtomLabel
						v-for="tag in tags"
						:key="tag"
						size="sm"
						:variant="ColorVariantEnum.Light"
						class="hover:scale-105 transition-transform duration-200"
					>
						{{ tag }}
					</AtomLabel>
				</div>
			</div>
			<div class="flex flex-col gap-4 flex-wrap pt-2 text-right text-white/85">
				<p
					v-if="category"
					class="flex flex-col gap-1"
				>
					<span class="sr-only">Categorie</span>
					<span class="text-functional-size-xs font-bold text-nowrap">{{ category.title }}</span>
				</p>
				<p class="flex flex-col gap-1 ">
					<span class="sr-only">Gepubliceerd op</span>
					<time class="text-functional-size-xs text-nowrap">
						{{ formatDate(new Date(publishedAt), 'DD MMMM YYYY') }}
					</time>
				</p>
			</div>
		</div>
	</article>
</template>

<script setup lang="ts">
import { ColorVariantEnum } from '#base/core/enums/ColorVariantEnum';
import type { BlogCategoryType } from '#base/core/types/BlogCategoryType';
import type { ImageType } from '#base/core/types/ImageType';
import { formatDate } from '#base/helpers/dateHelpers';

defineProps<{
	url: string;
	title: string;
	shortDescription: string;
	tags?: string[];
	category: BlogCategoryType;
	publishedAt: string;
	featuredImage: ImageType;
}>();
</script>
